<template>
    <div>
        <div v-if="isViewMode">
            <img :src="metadata.url" height="100">
            <div><strong>Label:</strong> <span>{{ contentValue.label }}</span></div>
            <div><strong>ALT text:</strong> <span>{{ contentValue.alt_text }}</span></div>
        </div>

        <div v-else-if="isEditMode">
            <input v-show="!isUploading && !didUploadImage" type="file" ref="uploadField" @change="uploadImage"
                   class="form-control-file">
            <div v-if="isUploading">Uploading image...</div>
            <div v-if="!isUploading && !didUploadImage">
                <div class="row">
                    <div class="col-4">
                        <div class="imagecontent-image-box">
                            <img :src="metadata.url" height="100">
                        </div>
                    </div>
                    <div class="col-8">
                        <input type="text" v-model="contentData.alt_text" placeholder="ALT text" class="form-control mb-1" />
                        <input type="text" v-model="contentData.label" placeholder="Label" class="form-control" />
                    </div>
                </div>
            </div>
            <div v-if="!isUploading && didUploadImage">
                <div class="row">
                    <div class="col-4">
                        <div class="imagecontent-image-box">
                            <img :src="uploadedImage.url" height="100">
                        </div>
                    </div>
                    <div class="col-8">
                        <input type="text" v-model="contentData.alt_text" placeholder="ALT text" class="form-control mb-1" />
                        <input type="text" v-model="contentData.label" placeholder="Label" class="form-control" />
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="isCreateMode">
            <input v-show="!isUploading && !didUploadImage" type="file" ref="uploadField" @change="uploadImage"
                   class="form-control-file">
            <div v-if="isUploading">Uploading image...</div>
            <div v-if="didUploadImage">
                <div class="row">
                    <div class="col-4">
                        <div class="imagecontent-image-box">
                            <img :src="uploadedImage.url" height="100">
                        </div>
                    </div>
                    <div class="col-8">
                        <input type="text" v-model="contentData.alt_text" placeholder="ALT text" class="form-control mb-1" />
                        <input type="text" v-model="contentData.label" placeholder="Label" class="form-control" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import ContentMixin from './ContentMixin';
    import modelFormLocker from '../../../modelFormLocker';

    export default {
        name: "ImageContent",
        mixins: [ContentMixin],

        methods: {
            uploadImage(event) {
                modelFormLocker.lock();

                let formData = new FormData();
                this.isUploading = true;


                formData.append('image', event.target.files[0]);

                axios.post(
                        '/admin/api/temporary-images',
                        formData,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                ).then((res) => {
                    this.isUploading = false;
                    this.resetUploadField();
                    this.handleSuccessfulUpload(res.data);
                    modelFormLocker.unlock();
                    this.didUploadImage = true;
                }).catch((res) => {
                    console.error(res);
                    this.isUploading = false;
                    alert('Something went wrong during upload. Please try again.');
                    this.resetUploadField();
                    modelFormLocker.unlock();
                });
            },
            handleSuccessfulUpload(image) {
                Object.assign(this.uploadedImage, {}, image);
                this.$set(this.contentData, 'new_image', image);
            },
            resetUploadField() {
                this.$refs.uploadField.value = '';
            }
        },

        data: () => ({
            uploadedImage: {
                url: null
            },
            isUploading: false,
            didUploadImage: false
        })
    };
</script>

<style scoped lang="scss">
@import "../../../../sass/variables.scss";

.imagecontent-image-box{
    width: 120px;
    height: 120px;
    background-color: #fff;
    border-radius: 1rem;
    border: 1px solid $gray-100;
    overflow: hidden;

    img{
        width: 120px;
        height: 120px;
        object-fit: contain;
    }
}
</style>
